module.exports = __webpack_public_path__ + "static/img/all.1156bfcb.png";